import { Routes } from '@angular/router';
import { MembershipAutoRenewFormStep } from '@aaa/emember/store-membership-auto-renew';
import checkPermissionForRemove from './guards/check-permission-for-remove';
import checkPermissionForUpdate from './guards/check-permission-for-update';
import checkPermissionForAdd from './guards/check-permission-for-add';
import setFormStep from './guards/set-form-step';
import { redirectToRenewIfBalanceDue } from '../account/guards/redirect-to-renew-if-balance-due.guard';
import { Breadcrumb } from '../../constants/pages';

export const membershipAutoRenewRoutes: Routes = [
  {
    path: 'add',
    pathMatch: 'full',
    loadComponent: () =>
      import('./components/auto-renew-form/auto-renew-form.component').then((c) => c.AutoRenewFormComponent),
    canActivate: [
      checkPermissionForAdd,
      redirectToRenewIfBalanceDue,
      setFormStep(MembershipAutoRenewFormStep.ADD_CARD),
    ],
    data: {
      showImage: true,
      breadcrumb: [Breadcrumb.account, Breadcrumb.accountMembership, Breadcrumb.accountMembershipAutoRenew],
    },
  },
  {
    path: 'update',
    pathMatch: 'full',
    loadComponent: () =>
      import('./components/auto-renew-form/auto-renew-form.component').then((c) => c.AutoRenewFormComponent),
    canActivate: [
      checkPermissionForUpdate,
      redirectToRenewIfBalanceDue,
      setFormStep(MembershipAutoRenewFormStep.UPDATE_CARD),
    ],
    data: {
      showImage: true,
      breadcrumb: [Breadcrumb.account, Breadcrumb.accountMembership, Breadcrumb.accountMembershipAutoRenew],
    },
  },
  {
    path: 'view',
    pathMatch: 'full',
    loadComponent: () =>
      import('./components/auto-renew-remove/auto-renew-remove.component').then((c) => c.AutoRenewRemoveComponent),
    canActivate: [checkPermissionForRemove],
    data: {
      showImage: true,
      breadcrumb: [Breadcrumb.account, Breadcrumb.accountMembership, Breadcrumb.accountMembershipAutoRenew],
    },
  },
  {
    path: '',
    redirectTo: '',
    pathMatch: 'full',
  },
];
